import React, { useEffect } from "react";
import Navbar from "./navbar";

import { Affix } from "antd";
import { SearchIcon } from "../shared/icons";

const Header: React.FC = () => {
  // const [hidden, setHidden] = useState(false);

  useEffect(() => {
    // const handleScroll = () => {
    //   const scrollTop =
    //     window.pageYOffset || document.documentElement.scrollTop;
    //   // 超過 100px 就把 Header 往上收起 86px，回到頂端就顯示
    //   setHidden(scrollTop > 100);
    // };
    // window.addEventListener("scroll", handleScroll);
    // return () => {
    //   window.removeEventListener("scroll", handleScroll);
    // };
  }, []);

  return (
    <Affix offsetTop={0}>
      {/* ${ hidden ? "-translate-y-[86px]" : "-translate-y-0" } */}
      <div
        className={`w-full flex justify-center border-b-[1px] md:px-8 px-2 bg-white transition-transform duration-300 ease-in-out 
          
         
          `}
      >
        <div className="w-full md:h-[98px] h-[78px] px-8 flex items-center justify-between">
          <Navbar />
          <div
            className="cursor-pointer flex items-center gap-x-1 xl:mr-10 lg:mr-2"
            onClick={() => (window.location.href = "/")}
          >
            <span className="lg:text-4xl md:text-3xl text-[22px] font-bold">
              Explore
            </span>
            <img
              src="/favicon.png"
              alt="logo"
              className="lg:w-12 lg:h-12 w-11 h-11 rounded-full"
            />
            <span className="lg:text-4xl md:text-3xl text-[22px] font-bold">
              Asia
            </span>
          </div>

          <button
            onClick={() => (window.location.href = "/search")}
            className="flex items-center gap-x-2"
          >
            {/* <img
              src="/icon/search.png"
              alt="searchBtn"
              className="lg:w-10 lg:h-10 w-7 h-7"
            /> */}
            <SearchIcon />
            {/* <span className="font-semibold text-[#5c687a] text-base">
              Search
            </span> */}
          </button>
        </div>
      </div>
    </Affix>
  );
};

export default Header;
